"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const RegistrationQuestionnaireHeader = () => (react_1.default.createElement("div", { className: "rightsholder-registration-scene-header" },
    react_1.default.createElement(ContentHeader_1.default, { title: "New Member Survey Questions", descriptionElement: react_1.default.createElement("p", null, "Below, please tell us a little more about your catalog.") })));
exports.default = RegistrationQuestionnaireHeader;
